import { render, staticRenderFns } from "./GlobalToast.vue?vue&type=template&id=53182012&scoped=true&"
import script from "./GlobalToast.vue?vue&type=script&lang=ts&"
export * from "./GlobalToast.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalToast.vue?vue&type=style&index=0&id=53182012&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53182012",
  null
  
)

export default component.exports